import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { TextField } from '@mui/material';

import {
  BaseLabel,
  RadioLabel,
  Label,
  AutoCompleteSmall,
  RowContainer,
  InputSmall,
} from '../../../../styles/styleUtils';
import CampoMonetario from '../../components/CampoMonetario';
import config from '../../../../config.json';
import { getContasBancario, getFormasPagamento } from '../../../api';

const RadioButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 15px;
`;

const RadioButton = styled.input`
  margin-right: 5px;
`;

function formatDateToInputValue(date) {
  const localDate = new Date(date);
  localDate.setMinutes(localDate.getMinutes() - localDate.getTimezoneOffset()); // Corrige fuso
  return localDate.toISOString().split('T')[0];
}

function PaymentDetails({
  onCustomerTypeChange,
  tipoRecebimento,
  formData,
  onAutoCompleteChange,
  onInputChange,
  onInclusao,
}) {
  const [formas, setFormas] = useState([]);
  const [contas, setContas] = useState([]);
  const unidades = config.unidades;

  const fetchFormas = async () => {
    const result = await getFormasPagamento();
    setFormas(result);
  };
  useEffect(() => {
    fetchFormas();
  }, []);

  const fetchContas = async () => {
    const result = await getContasBancario();
    setContas(result);
  };
  useEffect(() => {
    fetchContas();
  }, []);

  return (
    <div>
      <RowContainer>
        <BaseLabel htmlFor="formaPagamento">Forma de Pagamento</BaseLabel>
        <AutoCompleteSmall
          disablePortal
          id="formaPagamento"
          name="formaPagamento"
          value={formData.formaPagamento || null}
          onChange={(_, value) => onAutoCompleteChange('idFormaPagamento', 'formaPagamento', value)}
          options={formas}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} placeholder="Selecione" />}
        />
      </RowContainer>
      <RowContainer>
        <BaseLabel htmlFor="unidade">Unidade</BaseLabel>
        <AutoCompleteSmall
          disablePortal
          id="unidade"
          value={formData.unidade || null}
          options={unidades}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} placeholder="Selecione" />}
          onChange={(_, value) => onAutoCompleteChange(null, 'unidade', value)}
          disabled={formData.idVenda}
        />
        <spam />
        <spam />
        <spam />
        <spam />
        <spam />
        <Label htmlFor="dataRecebimento">Data Recebimento</Label>
        <InputSmall
          type="date"
          id="dataRecebimento"
          name="dataRecebimento"
          value={formData.dataRecebimento ? formatDateToInputValue(formData.dataRecebimento) : ''}
          onChange={onInputChange}
          disabled={formData.quantidadeParcelas > 1}
        />
      </RowContainer>
      {formData.dataRecebimento && (
        <>
          <RowContainer>
            <BaseLabel>Tipo de Recebimento</BaseLabel>
            <RadioButtonWrapper>
              <RadioButton
                type="radio"
                name="tipoRecebimento"
                value="T"
                checked={tipoRecebimento === 'T'}
                onChange={onCustomerTypeChange}
              />
              <RadioLabel>Total</RadioLabel>
            </RadioButtonWrapper>
            {!onInclusao && !formData.documentoOrigem && (
              <RadioButtonWrapper>
                <RadioButton
                  type="radio"
                  name="tipoRecebimento"
                  value="P"
                  checked={tipoRecebimento === 'P'}
                  onChange={onCustomerTypeChange}
                />
                <RadioLabel>Parcial</RadioLabel>
              </RadioButtonWrapper>
            )}
          </RowContainer>

          <RowContainer>
            <BaseLabel htmlFor="valorBaixa">Valor Baixa</BaseLabel>
            <CampoMonetario
              name={'valorBaixa'}
              valor={formData.valorBaixa || 0}
              onChange={onInputChange}
              disabled={formData.tipoRecebimento === 'T'}
            />
            <spam />
            <spam />
            <spam />
            <spam />
            <spam />
            {formData.valorBaixa && (
              <>
                <Label htmlFor="desconto">Desconto</Label>
                <CampoMonetario name={'desconto'} valor={formData.desconto || 0} onChange={onInputChange} />
                <Label htmlFor="acrescimo">Acréscimo</Label>
                <CampoMonetario name={'acrescimo'} valor={formData.acrescimo || 0} onChange={onInputChange} />
                <Label htmlFor="encargos">Encargos</Label>
                <CampoMonetario name={'encargos'} valor={formData.encargos || 0} onChange={onInputChange} disabled />
                <Label htmlFor="valorLiquido">Líquido</Label>
                <CampoMonetario
                  name={'valorLiquido'}
                  valor={formData.valorLiquido || 0}
                  onChange={onInputChange}
                  disabled
                />
              </>
            )}
          </RowContainer>

          <RowContainer>
            <BaseLabel htmlFor="contaRecebimento">Conta Recebimento</BaseLabel>
            <AutoCompleteSmall
              disablePortal
              id="contaRecebimento"
              name="contaRecebimento"
              value={formData.contaRecebimento || null}
              onChange={(_, value) => onAutoCompleteChange('idContaRecebimento', 'contaRecebimento', value)}
              options={contas}
              isOptionEqualToValue={(option, value) => option._id === value._id}
              getOptionLabel={(option) => `${option.nome}`}
              renderInput={(params) => <TextField {...params} placeholder="Selecione" />}
            />
          </RowContainer>
        </>
      )}
    </div>
  );
}

export default PaymentDetails;
